var _style, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _polyline;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 66.9 12.9",
    style: {
      enableBackground: "new 0 0 66.9 12.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);fill:#4967A9;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 0,
    width: 66.9,
    height: 12.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.2,2c-0.8,0-1,0.4-1,1.1v1.3h2.1L6.1,6.5H4.2v6.3H1.7V6.5H0V4.4h1.7V3.2C1.7,1.1,2.5,0,4.9,0 C5.4,0,6,0,6.3,0.1V2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.5,8.3c0-2.3,1.1-4.1,3.4-4.1c1.3,0,2,0.6,2.4,1.5V4.4h2.4v8.3h-2.4v-1.3c-0.4,0.8-1.1,1.4-2.4,1.4 c-2.3,0-3.4-1.7-3.4-4.1 M9,8.9c0,1.2,0.5,2.1,1.6,2.1c1,0,1.6-0.8,1.6-1.9V8.2c0-1.2-0.5-1.9-1.6-1.9C9.5,6.2,9,7.1,9,8.3V8.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20,4.3c1,0,1.9,0.2,2.4,0.6l-0.6,1.8c-0.4-0.2-1-0.4-1.7-0.4c-1.4,0-2,0.8-2,2.1v0.5c0,1.3,0.6,2.1,2,2.1 c0.7,0,1.3-0.2,1.7-0.4l0.6,1.8c-0.5,0.4-1.4,0.6-2.4,0.6c-3,0-4.3-1.6-4.3-4.1V8.4C15.7,5.8,17,4.3,20,4.3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.7,8.9V8.2c0-2.4,1.3-3.9,4.1-3.9c2.6,0,3.7,1.6,3.7,3.9v1.3h-5.3c0.1,1.1,0.6,1.6,2,1.6 c0.9,0,1.9-0.2,2.7-0.5l0.5,1.7c-0.7,0.3-2,0.6-3.2,0.6C23.9,12.9,22.7,11.4,22.7,8.9 M25.2,7.8h3V7.6c0-0.9-0.4-1.6-1.5-1.6 C25.7,6,25.2,6.7,25.2,7.8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.9,8.9c0,2.3-1.1,4.1-3.4,4.1c-1.3,0-2.1-0.6-2.5-1.4v1.3h-2.4V0.2L34.1,0v5.6c0.4-0.7,1.2-1.3,2.3-1.3 c2.3,0,3.4,1.7,3.4,4.1 M37.4,8.3c0-1.2-0.5-2-1.7-2c-1,0-1.6,0.7-1.6,1.9V9c0,1.2,0.6,1.9,1.6,1.9c1.2,0,1.7-0.9,1.7-2V8.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.7,8.8V8.4c0-2.4,1.4-4.1,4.1-4.1C47.6,4.3,49,6,49,8.4v0.4c0,2.4-1.4,4.1-4.1,4.1 C42.1,12.9,40.7,11.2,40.7,8.8 M46.5,8.2c0-1.1-0.5-2-1.6-2c-1.2,0-1.6,0.9-1.6,2V9c0,1.1,0.5,2,1.6,2c1.2,0,1.6-0.9,1.6-2V8.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.8,8.8V8.4c0-2.4,1.4-4.1,4.1-4.1c2.8,0,4.1,1.7,4.1,4.1v0.4c0,2.4-1.4,4.1-4.1,4.1 C51.2,12.9,49.8,11.2,49.8,8.8 M55.6,8.2c0-1.1-0.5-2-1.6-2c-1.2,0-1.6,0.9-1.6,2V9c0,1.1,0.5,2,1.6,2c1.2,0,1.6-0.9,1.6-2V8.2z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "61.6,8.4 64.1,4.4 66.8,4.4 64.1,8.5 66.9,12.8 64.2,12.8 61.6,8.7 61.6,12.8 59.1,12.8 59.1,0.2  61.6,0  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.8933b87f70c609e19b81152af4ce9d2f.svg";
export { ForwardRef as ReactComponent };